<script setup>
import Navbar from '@/components/NavBar.vue'
import Sidebar from '@/components/SideBar.vue'
import BarChart from '@/components/BarChart.vue'
import Doughnut from '@/components/DoughnutChart.vue'
// import { saleService } from '@/services/SaleService'
import { useSaleStore } from '@/stores/SaleStore'
import { useMiscStore } from '@/stores/MiscStore'
import { authenticationService } from '@/services/AuthenticationService'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'

const saleStore = useSaleStore()
const miscStore = useMiscStore()
const {
  orders, transSecOptions, transSecSeries, transCodeOptions, transCodeSeries, transFrontlineOptions, transFrontlineSeries, holdShipmentOptions, holdShipmentSeries, cusCodeOptions, cusCodeSeries, cusBirthOptions, cusBirthSeries,
  summary, recentOrders, highPoints
} = storeToRefs(saleStore)
const {
  regionCities, cities, subsidiaries
} = storeToRefs(miscStore)
const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const {
  getNoOfCustByCode, getNoOfTransByCode, getNoOfTransBySector, getCustByMonth, numberOfCusByCode, numberOfTransByCode, numberOfTransBySector, cusByMonth, frontlineSummary, marketerSummary, corpSummary,
  noOfSaleOrders, highPointCus, noOfShipsAtOrigin, noOfShipsAtDest, noOfShipsOnTransit, noOfDiscShipsByHubs, operatorSummary, noOfShipsAtRegOrigin, noOfShipsAtRegDest, noOfShipsOnRegTransit, corpRecentOrders,
  managerSummary, downloadByOriginHubs, downloadByDestHubs, downloadByTransit, downloadByRegOriginHubs, downloadByRegDestHubs, downloadByRegTransit, downloadDiscByHubs,
  numberOfHoldShipmentByFrontline, numberOfTransByFrontline, getNoOfHoldShipByFrontline, getNoOfTransByFrontline, lmsSummary, lmsSummaryByCity, finSummary
} = saleStore
const { getRegionCities, getCities, getSubsidiaries } = miscStore

const currentUser = authenticationService.currentUserValue.user
const role = currentUser.roles[0]
console.log('role', role)

const reloadLmsSummary = (e) => {
  const { value } = e.target
  console.log(value)
  lmsSummary()
}
const reloadLmsSummaryCity = (e) => {
  const { value } = e.target
  console.log(value)
  lmsSummaryByCity(miscStore.cityId)
}

onMounted(() => {
  if (role === 'Global Administrator' || role === 'Administrator') {
    marketerSummary()
    numberOfCusByCode()
    numberOfTransByCode()
    numberOfTransBySector()
    numberOfTransByFrontline()
    numberOfHoldShipmentByFrontline()
    cusByMonth()
    if (role === 'Administrator') {
      marketerSummary(saleStore.currentUser?.sbuUser?.sbuId)
    } else {
      marketerSummary(null)
    }
  }
  if (role === 'FrontLine') {
    frontlineSummary()
    noOfSaleOrders()
    highPointCus()
  }
  if ((role === 'Operator') && saleStore.currentUser.sbuUser.sbuId !== 3) {
    noOfShipsAtOrigin(saleStore.currentFrontline.hub.cityId)
    noOfShipsAtDest(saleStore.currentFrontline.hub.cityId)
    noOfShipsOnTransit(saleStore.currentFrontline.hub.cityId)
    lmsSummary()
    noOfDiscShipsByHubs(saleStore.currentFrontline.hub.cityId, 1)
  }
  if ((role === 'Operator') && saleStore.currentUser.sbuUser.sbuId === 3) {
    noOfShipsAtOrigin(saleStore.currentFrontline.airportId)
    noOfShipsAtDest(saleStore.currentFrontline.airportId)
    noOfShipsOnTransit(saleStore.currentFrontline.airportId)
    operatorSummary(saleStore.currentUser.sbuUser.sbuId)
    noOfDiscShipsByHubs(saleStore.currentFrontline.airportId, 1)
  }
  if (role === 'Manager') {
    if (saleStore.currentFrontline.type === 1) {
      noOfShipsAtOrigin(saleStore.currentFrontline.area)
      noOfShipsAtDest(saleStore.currentFrontline.area)
      noOfShipsOnTransit(saleStore.currentFrontline.area)
      noOfDiscShipsByHubs(saleStore.currentFrontline.area, saleStore.currentFrontline.type)
    }
    if (saleStore.currentFrontline.type === 2) {
      getRegionCities(saleStore.currentFrontline.area)
      noOfShipsAtRegOrigin()
      noOfShipsAtRegDest()
      noOfShipsOnRegTransit()
      noOfDiscShipsByHubs(saleStore.currentFrontline.area, saleStore.currentFrontline.type)
      lmsSummaryByCity(miscStore.cityId)
    }
    managerSummary()
  }
  if (role === 'Service Assurance') {
    getSubsidiaries()
    getCities()
    lmsSummaryByCity(2)
  }
  if (role === 'Customer') {
    corpSummary()
    corpRecentOrders()
  }
  if (role === 'Billing') {
    finSummary(saleStore.currentUser.sbuUser.sbuId)
  }
})
</script>

<script>

export default {
  data () {
    return {
      ordersHeaders: [
        {
          key: 'date',
          label: 'DATE'
        },
        {
          key: 'waybillNo',
          label: 'NUMBER'
        }
      ],
      pointHeaders: [
        {
          key: 'accountNo',
          label: 'Account Number'
        },
        {
          key: 'name',
          label: 'Full Name'
        },
        {
          key: 'centre',
          label: 'Centre Code'
        },
        {
          key: 'email',
          label: 'Email'
        },
        {
          key: 'points',
          label: 'Points'
        }
      ],
      orderHeaders: [
        {
          key: 'orderDate',
          label: 'Order Date'
        },
        {
          key: 'waybillNo',
          label: 'Waybill No'
        },
        {
          key: 'recipientName',
          label: 'Recipient Name'
        },
        {
          key: 'recipientPhone',
          label: 'Recipient Phone'
        },
        {
          key: 'origin',
          label: 'Origin'
        },
        {
          key: 'destination',
          label: 'Destination'
        },
        {
          key: 'status',
          label: 'Status'
        }
      ],
      statuses: [
        { id: 0, name: 'New' },
        { id: 1, name: 'Picked' },
        { id: 2, name: 'Arrived at Origin Hub' },
        { id: 3, name: 'Arrived at Transit Gateway' },
        { id: 4, name: 'Awaiting Crating/Packing' },
        { id: 5, name: 'Reweighed' },
        { id: 6, name: 'Sorted to Destination City' },
        { id: 7, name: 'Departed Transit Gateway' },
        { id: 8, name: 'Arrived DBM' },
        { id: 9, name: 'Assigned Courier' },
        { id: 10, name: 'Departed DBM' },
        { id: 11, name: 'In Transit to Destination Hub' },
        { id: 12, name: 'Arrived after Courier Dispatched' },
        { id: 13, name: 'Arrived at Destination Hub' },
        { id: 14, name: 'Reweighed by Destination Hub' },
        { id: 15, name: 'Debagged by Destination Hub' },
        { id: 16, name: 'In Transit' },
        { id: 17, name: 'Held for Collection' },
        { id: 18, name: 'Arrived Damaged' },
        { id: 19, name: 'Damage Observed' },
        { id: 20, name: 'Delivered' },
        { id: 21, name: 'Dealy Beyond our Control' },
        { id: 22, name: 'Partial Delivered' },
        { id: 24, name: 'With Delivery Courier' },
        { id: 99, name: 'Delay with Exception' },
        { id: 55, name: 'Scanned' },
        { id: 50, name: 'Awaiting Scan at Pickup' },
        { id: 100, name: 'Returned To Origin' },
        { id: 200, name: 'Returned To Merchant' },
        { id: 500, name: 'Offline Delivered' }
      ],
      sidebarVisible: false
    }
  },
  methods: {
    toggleSidebar (isVisible) {
      this.sidebarVisible = isVisible
      console.log('parentSide', this.sidebarVisible)
    },
    statusDefinition (status) {
      switch (status) {
        case 0:
          return 'New'
        case 1:
          return 'Picked'
        case 2:
          return 'Arrived At Origin Station'
        case 3:
          return 'Arrived At Origin Station'
        case 4:
          return 'Arrived At Origin Station'
        case 5:
          return 'Arrived At Origin Station'
        case 6:
          return 'Arrived At Origin Station'
        case 7:
          return 'Departed At Origin Station'
        case 8:
          return 'Departed At Origin Station'
        case 9:
          return 'Departed At Origin Station'
        case 10:
          return 'Departed At Origin Station'
        case 11:
          return 'Departed At Origin Station'
        case 12:
          return 'Arrived At Destination Station'
        case 13:
          return 'Arrived At Destination Station'
        case 14:
          return 'Arrived At Destination Station'
        case 15:
          return 'Arrived At Destination Station'
        case 16:
          return 'Arrived At Destination Station'
        case 17:
          return 'Held for Collection'
        case 18:
          return 'Arrived Damaged'
        case 19:
          return 'Damaged Observed'
        case 20:
          return 'Delivered'
        case 21:
          return 'Delay Beyond our Control'
        case 22:
          return 'Partial Delivered'
        case 99:
          return 'Delay With Exception'
        case 24:
          return 'With Delivery Courier'
        case 55:
          return 'Picked'
        case 50:
          return 'Picked'
        case 100:
          return 'Returned To Origin Station'
        case 200:
          return 'Returned To Merchant'
        case 500:
          return 'Delivered'
      }
    }
  }
}
</script>

<template>
  <div class="">
    <Navbar></Navbar>
    <Sidebar />
    <div class="main-content">
      <div class="row">
        <div class="col-12 col-sm-9 mt-2">
          <span class="welcome">Welcome {{ currentUser.firstName }}</span>
        </div>
        <div class="form group col-12 col-sm-1"  v-if="currentUser.roles[0] === 'Manager'">
          <select class="form-select select-cat mt-2" aria-label="Default select example" v-model="miscStore.cityId" @change="reloadLmsSummaryCity($event)">
            <option :value="null">Please Select</option>
            <option
              v-for="s in regionCities"
              :key="s.cityId"
              :value="s.cityId"
            >{{ s.city.abbr }}</option>
          </select>
        </div>
        <div class="form group col-12 col-sm-1"  v-if="currentUser.roles[0] === 'Service Assurance'">
          <select class="form-select select-cat mt-2" aria-label="Default select example" v-model="saleStore.subsidiaryId" @change="reloadLmsSummaryCity($event)">
            <option :value="null">Please Select</option>
            <option
              v-for="s in subsidiaries"
              :key="s.id"
              :value="s.id"
            >{{ s.name }}</option>
          </select>
        </div>
        <div class="form group col-12 col-sm-1"  v-if="currentUser.roles[0] === 'Service Assurance'">
          <select class="form-select select-cat mt-2" aria-label="Default select example" v-model="miscStore.cityId" @change="reloadLmsSummaryCity($event)">
            <option :value="null">Please Select City</option>
            <option
              v-for="s in cities"
              :key="s.id"
              :value="s.id"
            >{{ s.abbr }}</option>
          </select>
        </div>
        <div class="form group col-12 col-sm-1"  v-if="currentUser.roles[0] === 'Manager' || currentUser.roles[0] === 'Service Assurance'">
          <select class="form-select select-cat mt-2" aria-label="Default select example" v-model="saleStore.period" @change="reloadLmsSummaryCity($event)">
            <option :value="null">Please Select</option>
            <option
              v-for="s in saleStore.periods"
              :key="s.value"
              :value="s.value"
            >{{ s.label }}</option>
          </select>
        </div>
        <div class="form group col-12 col-sm-2"  v-if="currentUser.roles[0] === 'Operator'">
          <select class="form-select select-cat mt-2" aria-label="Default select example" v-model="saleStore.period" @change="reloadLmsSummary($event)">
            <option :value="null">Please Select</option>
            <option
              v-for="s in saleStore.periods"
              :key="s.value"
              :value="s.value"
            >{{ s.label }}</option>
          </select>
        </div>
      </div>
      <div class="container-fluid py-4"  v-if="currentUser.roles[0] === 'Global Administrator' || currentUser.roles[0] === 'Administrator'">
        <div class="row mb-4">
          <div class="col-6 col-lg-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">EXPRESS CENTRES</p>
                  <p class="pane-text mb-0">{{ summary?.totalCentres ? summary?.totalCentres : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">CUSTOMERS</p>
                  <p class="pane-text mb-0">{{ summary?.totalCustomers ? summary?.totalCustomers : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">AVAILABLE DISCOUNTS</p>
                  <p class="pane-text mb-0">{{ summary?.totalDiscounts ? summary?.totalDiscounts : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">TOTAL SALE ORDERS</p>
                  <p class="pane-text mb-0">{{ summary?.totalSaleOrder ? summary?.totalSaleOrder : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Number of Registered Customers by Express Code
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.cusStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.cusEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="numberOfCusByCode()">
                        Search
                      </button>
                      <button v-if="cusCodeSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="getNoOfCustByCode()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="cusCodeOptions && cusCodeOptions" :series="cusCodeSeries" />
                  <div class="text-center">
                    <p class="chart-title">Top Customers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Number of Transactions by Express Code
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.transStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.transEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="numberOfTransByCode()">
                        Search
                      </button>
                      <button v-if="transCodeSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="getNoOfTransByCode()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transCodeOptions && transCodeOptions" :series="transCodeSeries" />
                  <div class="text-center">
                    <p class="chart-title">Top Transactions</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Number of Transactions by Frontline
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.cusStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.cusEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="numberOfTransByFrontline()">
                        Search
                      </button>
                      <button v-if="transFrontlineSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="getNoOfTransByFrontline()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transFrontlineOptions && transFrontlineOptions" :series="transFrontlineSeries" />
                  <div class="text-center">
                    <p class="chart-title">Top Transactions</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Number of Holding Shipment by Frontline (Daily)
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button v-if="holdShipmentSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="getNoOfHoldShipByFrontline()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="holdShipmentOptions && holdShipmentOptions" :series="holdShipmentSeries" />
                  <div class="text-center">
                    <p class="chart-title">Holding Shipment</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Number of Transactions by Sector
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.sectorStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.sectorEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="numberOfTransBySector()">
                        Search
                      </button>
                      <button v-if="transSecSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="getNoOfTransBySector()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transSecOptions && transSecOptions" :series="transSecSeries" />
                  <div class="text-center">
                    <p class="chart-title">Top Sectors</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Number of Customers by Birth Month
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="ms-auto">
                      <button v-if="cusBirthSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="getCustByMonth()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <Doughnut :options="cusBirthOptions && cusBirthOptions" :series="cusBirthSeries" />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="container-fluid py-4"  v-if="currentUser.roles[0] === 'Customer'">
        <div class="row mb-4">
          <span><b>TRANSACTION COUNT FOR {{ month[new Date().getMonth()]?.toUpperCase() }}, {{ new Date().getFullYear() }}</b></span>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Awaiting Pickup</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[0]?.pending : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">In Process</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[0]?.waiting : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[0]?.delivered : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Shipment With Exception</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[0]?.exception : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Returned Shipments</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[0]?.returned : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">All</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[0]?.pending + summary?.transactionCounts[0]?.waiting + summary?.transactionCounts[0]?.delivered + summary?.transactionCounts[0]?.exception + summary?.transactionCounts[0]?.returned : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <span><b>TRANSACTION COUNT FOR INCEPTION</b></span>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Awaiting Pickup</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[1]?.pending : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">In Process</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[1]?.waiting : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[1]?.delivered : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Shipment With Exception</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[1]?.exception : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Returned Shipments</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[1]?.returned : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">All</p>
                  <p class="pane-text mb-0">{{ summary?.transactionCounts ? summary?.transactionCounts[1]?.pending + summary?.transactionCounts[1]?.waiting + summary?.transactionCounts[1]?.delivered + summary?.transactionCounts[1]?.exception + summary?.transactionCounts[1]?.returned : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-lg-12 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Order Charts
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="pane px-3 py-3">
                  <BarChart :options="cusCodeOptions && cusCodeOptions" :series="summary.series" v-if="summary" />
                  <div class="text-center">
                    <p class="chart-title">Orders</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-lg-12">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Recent Orders
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="">
                  <b-table
                    class="elevation-1 frontline-table"
                    id="staffTable"
                    responsive
                    outlined
                    :fields="orderHeaders"
                    :items="orders"
                  >
                    <template #cell(orderDate)="data">
                      <div class="">
                      {{ data.item.createdOn ? new Date(data.item.createdOn).toLocaleDateString() : null }}
                      </div>
                    </template>
                    <template #cell(waybillNo)="data">
                      <div class="">
                      {{ data.item.waybillNumber }}
                      </div>
                    </template>
                    <template #cell(recipientName)="data">
                      <div class="">
                      {{ data.item.recipient.recipientName }}
                      </div>
                    </template>
                    <template #cell(recipientPhone)="data">
                      <div class="">
                      {{ data.item.recipient.phoneNumber }}
                      </div>
                    </template>
                    <template #cell(origin)="data">
                      <div class="">
                      {{ data.item.origin?.name }}
                      </div>
                    </template>
                    <template #cell(destination)="data">
                      <div class="">
                      {{ data.item.city?.name }}
                      </div>
                    </template>
                    <template #cell(status)="data">
                  <div class="">
                  {{ statusDefinition(data.item.
                  status) }}
                  </div>
                </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid py-4" v-if="currentUser.roles[0] === 'FrontLine'">
        <div class="row mb-4">
          <div class="col-12 col-sm-4 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Customers</p>
                  <p class="pane-text mb-0">{{ summary?.totalCustomers ? summary?.totalCustomers : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Available Discounts</p>
                  <p class="pane-text mb-0">{{ summary?.totalDiscounts ? summary?.totalDiscounts : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Sale Orders</p>
                  <p class="pane-text mb-0">{{ summary?.totalSaleOrder ? summary?.totalSaleOrder: 0 }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-lg-6">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Recent Orders
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="">
                  <b-table
                    class="elevation-1 frontline-table"
                    id="staffTable"
                    responsive
                    outlined
                    :fields="ordersHeaders"
                    :items="recentOrders"
                  >
                    <template #cell(date)="data">
                      <div class="">
                      {{ data.item.shipment.createdOn ? new Date(data.item.shipment.createdOn).toLocaleDateString() : null }}
                      </div>
                    </template>
                    <template #cell(waybillNo)="data">
                      <div class="">
                      {{ data.item.shipment.waybillNumber }}
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Highest Point Customers
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="">
                  <b-table
                    class="elevation-1 frontline-table"
                    id="staffTable"
                    responsive
                    outlined
                    :fields="pointHeaders"
                    :items="highPoints"
                  >
                    <template #cell(accountNo)="data">
                      <div class="">
                      {{ data.item.accountNo }}
                      </div>
                    </template>
                    <template #cell(name)="data">
                      <div class="">
                      {{ data.item.firstName + ' ' + data.item.lastName }}
                      </div>
                    </template>
                    <template #cell(centre)="data">
                      <div class="">
                      {{ data.item.expressCentreCode }}
                      </div>
                    </template>
                    <template #cell(email)="data">
                      <div class="">
                      {{ data.item.email ? data.item.email : 'N/A' }}
                      </div>
                    </template>
                    <template #cell(points)="data">
                      <div class="">
                      {{ data.item.rewardPoint.point ? data.item.rewardPoint.point.toFixed(3) : 0 }}
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid py-4"  v-if="currentUser.roles[0] === 'Operator' && currentUser.sbuUser.sbuId !== 3">
        <div class="row mb-2">
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">New</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.pending }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Scanned</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.scanned }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Picked</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.waiting }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.delivered }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Returned</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.returned }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Exception</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.exception }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered at AM (station)</p>
                  <p class="pane-text mb-0">{{ summary.deliveries?.AMDeliveriesForStation }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered at PM (station)</p>
                  <p class="pane-text mb-0">{{ summary.deliveries?.PMDeliveriesForStation }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered at AM (nationwide)</p>
                  <p class="pane-text mb-0">{{ summary.deliveries?.AMDeliveriesForAll }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered at PM (nationwide)</p>
                  <p class="pane-text mb-0">{{ summary.deliveries?.PMDeliveriesForAll }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight (Station)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightForStation).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight (NW)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightForAll).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered (Station)</p>
                  <p class="pane-text mb-0">{{ summary.others?.deliveredShipmentsForStation }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered (NW)</p>
                  <p class="pane-text mb-0">{{ summary.others?.deliveredShipmentsForAll }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Undelivered (Station)</p>
                  <p class="pane-text mb-0">{{ summary.others?.undeliveredShipmentsForStation }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Undelivered (NW)</p>
                  <p class="pane-text mb-0">{{ summary.others?.undeliveredShipmentsForAll }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight by Land (Station)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightByLandStation).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight by Land (Nationwide)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightByLandAll).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight by Air (Station)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightByAirStation).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight by Air (Nationwide)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightByAirAll).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Shipment at Origin Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.cusStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.cusEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="noOfShipsAtOrigin(saleStore.currentFrontline.hub.cityId)">
                        Search
                      </button>
                      <button v-if="cusCodeSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadByOriginHubs(saleStore.currentFrontline.hub.cityId)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="cusCodeOptions && cusCodeOptions" :series="cusCodeSeries" />
                  <div class="text-center">
                    <p class="chart-title">Status at Origin Hubs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Shipment at Destination Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.transStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.transEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="noOfShipsAtDest(saleStore.currentFrontline.hub.cityId)">
                        Search
                      </button>
                      <button v-if="transCodeSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadByDestHubs(saleStore.currentFrontline.hub.cityId)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transCodeOptions && transCodeOptions" :series="transCodeSeries" />
                  <div class="text-center">
                    <p class="chart-title">Status at Destination Hubs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Shipment on Transit
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.sectorStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.sectorEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="noOfShipsOnTransit(saleStore.currentFrontline.hub.cityId)">
                        Search
                      </button>
                      <button v-if="transSecSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadByTransit(saleStore.currentFrontline.hub.cityId)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transSecOptions && transSecOptions" :series="transSecSeries" />
                  <div class="text-center">
                    <p class="chart-title">Status on Transit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Discrepancy Shipment by Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="ms-auto">
                      <button v-if="cusBirthSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadDiscByHubs(saleStore.currentFrontline.hub.cityId, 1)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <Doughnut :options="cusBirthOptions && cusBirthOptions" :series="cusBirthSeries" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid py-4"  v-if="currentUser.roles[0] === 'Operator' && currentUser.sbuUser.sbuId === 3">
        <div class="row mb-4">
          <div class="col-12 col-sm-4 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Arrived Shipments</p>
                  <p class="pane-text mb-0">{{ summary.totalArrivedShipments }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Processed Shipments</p>
                  <p class="pane-text mb-0">{{ summary.totalProcessedShipments }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Delayed Shipment</p>
                  <p class="pane-text mb-0">{{ summary.totalDelayedShipments }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Shipment at Origin Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.cusStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.cusEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="noOfShipsAtOrigin(saleStore.currentFrontline.airportId)">
                        Search
                      </button>
                      <button v-if="cusCodeSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadByOriginHubs(saleStore.currentFrontline.airportId)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="cusCodeOptions && cusCodeOptions" :series="cusCodeSeries" />
                  <div class="text-center">
                    <p class="chart-title">Status at Origin Hubs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Shipment at Destination Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.transStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.transEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="noOfShipsAtDest(saleStore.currentFrontline.airportId)">
                        Search
                      </button>
                      <button v-if="transCodeSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadByDestHubs(saleStore.currentFrontline.airportId)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transCodeOptions && transCodeOptions" :series="transCodeSeries" />
                  <div class="text-center">
                    <p class="chart-title">Status at Destination Hubs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Shipment on Transit
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.sectorStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.sectorEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="noOfShipsOnTransit(saleStore.currentFrontline.airportId)">
                        Search
                      </button>
                      <button v-if="transSecSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadByTransit(saleStore.currentFrontline.airportId)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transSecOptions && transSecOptions" :series="transSecSeries" />
                  <div class="text-center">
                    <p class="chart-title">Status on Transit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0">
                  Discrepancy Shipment by Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="ms-auto">
                      <button v-if="cusBirthSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadDiscByHubs(saleStore.currentFrontline.airportId, 1)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <Doughnut :options="cusBirthOptions && cusBirthOptions" :series="cusBirthSeries" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid py-4"  v-if="currentUser.roles[0] === 'Manager' || currentUser.roles[0] === 'Service Assurance'">
        <div class="row mb-2">
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">New</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.pending }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Scanned</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.scanned }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Picked</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.waiting }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.delivered }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Returned</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.returned }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Exception</p>
                  <p class="pane-text mb-0">{{ summary.transactionCount?.exception }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered at AM (station)</p>
                  <p class="pane-text mb-0">{{ summary.deliveries?.AMDeliveriesForStation }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered at PM (station)</p>
                  <p class="pane-text mb-0">{{ summary.deliveries?.PMDeliveriesForStation }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered at AM (nationwide)</p>
                  <p class="pane-text mb-0">{{ summary.deliveries?.AMDeliveriesForAll }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered at PM (nationwide)</p>
                  <p class="pane-text mb-0">{{ summary.deliveries?.PMDeliveriesForAll }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight (Station)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightForStation).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight (NW)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightForAll).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered (Station)</p>
                  <p class="pane-text mb-0">{{ summary.others?.deliveredShipmentsForStation }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Delivered (NW)</p>
                  <p class="pane-text mb-0">{{ summary.others?.deliveredShipmentsForAll }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Undelivered (Station)</p>
                  <p class="pane-text mb-0">{{ summary.others?.undeliveredShipmentsForStation }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Undelivered (NW)</p>
                  <p class="pane-text mb-0">{{ summary.others?.undeliveredShipmentsForAll }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight by Land (Station)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightByLandStation).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight by Land (Nationwide)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightByLandAll).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight by Air (Station)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightByAirStation).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-3 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Total Weight by Air (Nationwide)</p>
                  <p class="pane-text mb-0">{{ Number(summary.others?.totalWeightByAirAll).toFixed(2) }} Kg</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4" v-if="currentUser.roles[0] === 'Manager'">
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0" v-if="saleStore.currentFrontline?.type === 2">
                  Shipment at Regional Origin Hubs
                </p>
                <p class="header-title mb-0" v-if="saleStore.currentFrontline?.type === 1">
                  Shipment at Origin Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.cusStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.cusEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="saleStore.currentFrontline?.type === 1 ? noOfShipsAtOrigin(saleStore.currentFrontline.area) : noOfShipsAtRegOrigin()">
                        Search
                      </button>
                      <button v-if="cusCodeSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="saleStore.currentFrontline?.type === 1 ? downloadByOriginHubs(saleStore.currentFrontline.area) : downloadByRegOriginHubs()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="cusCodeOptions && cusCodeOptions" :series="cusCodeSeries" />
                  <div class="text-center">
                    <p class="chart-title" v-if="saleStore.currentFrontline?.type === 1">Status at Origin Hubs</p>
                    <p class="chart-title" v-if="saleStore.currentFrontline?.type === 2">Status at Region Origin Hubs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0" v-if="saleStore.currentFrontline?.type === 1">
                  Shipment at Destination Hubs
                </p>
                <p class="header-title mb-0" v-if="saleStore.currentFrontline?.type === 2">
                  Shipment at Regional Destination Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.transStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.transEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="saleStore.currentFrontline?.type === 1 ? noOfShipsAtDest(saleStore.currentFrontline.area) : noOfShipsAtRegDest()">
                        Search
                      </button>
                      <button v-if="transCodeSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="saleStore.currentFrontline?.type === 1 ? downloadByDestHubs(saleStore.currentFrontline.area) : downloadByRegDestHubs()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transCodeOptions && transCodeOptions" :series="transCodeSeries" />
                  <div class="text-center">
                    <p class="chart-title" v-if="saleStore.currentFrontline?.type === 1">Status at Destination Hubs</p>
                    <p class="chart-title" v-if="saleStore.currentFrontline?.type === 2">Status at Region Destination Hubs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0" v-if="saleStore.currentFrontline?.type === 1">
                  Shipment on Transit
                </p>
                <p class="header-title mb-0" v-if="saleStore.currentFrontline?.type === 2">
                  Shipment on Transit By Region
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="form-input">
                      <div class="d-flex align-items-center py-1 w-100">
                        <div class="d-flex w-50">
                          <label for="startDate" class=" py-0 px-1 col-form-label pane-form-label">from</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="startDate" v-model="saleStore.sectorStartDate">
                          </div>
                        </div>
                        <div class="d-flex w-50">
                          <label for="endDate" class=" py-0 px-1 col-form-label pane-form-label">to</label>
                          <div class=" px-0 w-75">
                            <input type="date" class="form-control py-0 px-1 pane-form-input" id="endDate" v-model="saleStore.sectorEndDate">
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="divide mx-2 my-0" />
                    <div class="d-flex">
                      <button class="btn btn-sm action-btn" @click="saleStore.currentFrontline?.type === 1 ? noOfShipsOnTransit(saleStore.currentFrontline.area) : noOfShipsOnRegTransit()">
                        Search
                      </button>
                      <button v-if="transSecSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="saleStore.currentFrontline?.type === 1 ? downloadByTransit(saleStore.currentFrontline.area) : downloadByRegTransit()">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <BarChart :options="transSecOptions && transSecOptions" :series="transSecSeries" />
                  <div class="text-center">
                    <p class="chart-title">Status on Transit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <div class="card stat-pane-card">
              <div class="card-header">
                <p class="header-title mb-0" v-if="saleStore.currentFrontline?.type === 1">
                  Discrepancy Shipment by Hubs
                </p>
                <p class="header-title mb-0" v-if="saleStore.currentFrontline?.type === 2">
                  Discrepancy Shipment by Region Hubs
                </p>
              </div>
              <div class="card-body py-0 px-0">
                <div class="body-pane-head px-3">
                  <div class="d-flex py-3">
                    <div class="ms-auto">
                      <button v-if="cusBirthSeries.length > 0" class="btn btn-sm action-btn mx-2" @click="downloadDiscByHubs(saleStore.currentFrontline.area, saleStore.currentFrontline.type)">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div class="pane px-3 py-3">
                  <Doughnut :options="cusBirthOptions && cusBirthOptions" :series="cusBirthSeries" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid py-4"  v-if="currentUser.roles[0] === 'Billing'">
        <div class="row mb-4" v-for="summ in summary" :key="summ.duration">
          <span><b>TRANSACTION FOR {{ summ.duration }}</b></span>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Awaiting Pod (Corps)</p>
                  <p class="pane-text mb-0">{{ summ?.summary ? summ?.summary?.awaitingCorpPods : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Awaiting Pod (Walkin)</p>
                  <p class="pane-text mb-0">{{ summ?.summary ? summ?.summary?.awaitingWalkinPods : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">All Shipments</p>
                  <p class="pane-text mb-0">{{ summ?.summary ? summ?.summary?.allCorpShipments + summ?.summary?.allWalkinShipments : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Revenue (Walkin)</p>
                  <p class="pane-min-text mb-0">{{ summ?.summary ? (!summ?.summary?.walkingRevenue ? 0 : summ?.summary?.walkingRevenue).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Revenue Exp (Corp)</p>
                  <p class="pane-min-text mb-0">{{ summ?.summary ? (!summ?.summary?.corpRevenueExpected ? 0 : summ?.summary?.corpRevenueExpected).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-2 mb-2">
            <div class="card header-pane-card">
              <div class="card-body">
                <div class="pane">
                  <p class="pane-title">Revenue Gen (Corp)</p>
                  <p class="pane-min-text mb-0">{{ summ?.summary ? (!summ?.summary?.corpRevenueGranted ? 0 : summ?.summary?.corpRevenueGranted).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
